import React, { useState } from 'react';
import { Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { Delivery, Fabrics, Sewing, Time } from '../icons';
import { texts } from './constants';
import {
	BrandAttributeContainer,
	BrandAttributeModal,
	BrandAttributeText,
	BrandAttributeTextChevron,
} from './styles';
import { DeliveryModal, FabricsModal, SewingModal, TimeModal } from './modals';

type BrandAttributeProps = {
	onClick: VoidFunction;
};

type BaseBrandAttributeProps = {
	text: React.ReactNode;
	icon: React.ReactNode;
	onOpen: VoidFunction;
	dataQa: string;
};

const BrandAttribute = ({ text, icon, dataQa, onOpen }: BaseBrandAttributeProps) => (
	<BrandAttributeContainer data-qa={dataQa} role="button" onClick={onOpen}>
		{icon}
		<BrandAttributeText>
			<Typography as="p" size="body_long" variant="m">
				{text}
			</Typography>
			<BrandAttributeTextChevron>
				<ChevronRightIcon type="outline" size="l" color="text-minor" />
			</BrandAttributeTextChevron>
		</BrandAttributeText>
	</BrandAttributeContainer>
);

export const FabricsBrandAttribute = () => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => setIsOpen(prev => !prev);
	return (
		<>
			<BrandAttribute
				dataQa="fabrics-brand-attribute"
				text={texts.attributes.fabrics.title}
				icon={<Fabrics />}
				onOpen={toggleOpen}
			/>
			<BrandAttributeModal>
				<FabricsModal isOpen={isOpen} onClose={toggleOpen} />
			</BrandAttributeModal>
		</>
	);
};

export const TimeBrandAttribute = () => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => setIsOpen(prev => !prev);
	return (
		<>
			<BrandAttribute
				dataQa="time-brand-attribute"
				text={texts.attributes.time.title}
				icon={<Time />}
				onOpen={toggleOpen}
			/>
			<BrandAttributeModal>
				<TimeModal isOpen={isOpen} onClose={toggleOpen} />
			</BrandAttributeModal>
		</>
	);
};

export const SewingBrandAttribute = ({ onClick }: BrandAttributeProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => setIsOpen(prev => !prev);
	return (
		<>
			<BrandAttribute
				dataQa="sewing-brand-attribute"
				text={texts.attributes.sewing.title}
				icon={<Sewing />}
				onOpen={toggleOpen}
			/>
			<BrandAttributeModal>
				<SewingModal isOpen={isOpen} onClose={toggleOpen} onClick={onClick} />
			</BrandAttributeModal>
		</>
	);
};

export const DeliveryBrandAttribute = ({ onClick }: BrandAttributeProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => setIsOpen(prev => !prev);
	return (
		<>
			<BrandAttribute
				dataQa="delivery-brand-attribute"
				text={texts.attributes.delivery.title}
				icon={<Delivery />}
				onOpen={toggleOpen}
			/>
			<BrandAttributeModal>
				<DeliveryModal isOpen={isOpen} onClose={toggleOpen} onClick={onClick} />
			</BrandAttributeModal>
		</>
	);
};
